import { createRouter, createWebHistory } from 'vue-router';
import Binance from './components/Binance.vue';
import BinanceNewUi from './components/BinanceNewUi.vue';
import Mexc from './components/Mexc.vue';
import AllCoins from './components/AllCoins.vue';
import BinanceAlpha from './components/BinanceAlpha.vue';
import Bybit from './components/Bybit.vue';
import FavoriteBinance from './components/favorite/FavoriteBinance.vue';
import Profile from './components/user/Profile.vue';
import AccountManagement from './components/user/AccountManagement.vue';
import Login from './components/auth/Login.vue';
import ForgotPassword from './components/auth/ForgotPassword.vue';
import ResetPassword from './components/auth/ResetPassword.vue';
import Forbidden from './components/auth/Forbidden.vue';
import { getAccessToken, isAdmin, isAuthenticated } from './services/authStorage';
import { getValidAccessToken } from './services/authRefresh';
import LongShortCompare from './components/LongShortCompare.vue';
import OrderbookView from './components/OrderbookView.vue';

const routes = [
  {
    path: '/',
    redirect: '/binance'
  },
  {
    path: '/overview',
    redirect: '/binance'
  },
  {
    path: '/binance',
    name: 'BinanceNewUi',
    component: BinanceNewUi,
    meta: { requiresAuth: true }
  },
  {
    path: '/binance/:coinName',
    name: 'BinanceNewUiCoin',
    component: BinanceNewUi,
    meta: { requiresAuth: true }
  },
  {
    path: '/binance-new-ui',
    redirect: '/binance'
  },
  {
    path: '/binance-new-ui/:coinName',
    redirect: to => `/binance/${to.params.coinName}`
  },
  {
    path: '/binance-old',
    name: 'Binance',
    component: Binance,
    meta: { requiresAuth: true }
  },
  {
    path: '/binance-old/:coinName',
    name: 'BinanceCoin',
    component: Binance,
    meta: { requiresAuth: true }
  },
  {
    path: '/binance-alpha',
    name: 'BinanceAlpha',
    component: BinanceAlpha,
    meta: { requiresAuth: true }
  },
  {
    path: '/mexc',
    name: 'Mexc',
    component: Mexc,
    meta: { requiresAuth: true }
  },
  {
    path: '/mexc/:coinName',
    name: 'MexcCoin',
    component: Mexc
  },
  {
    path: '/bybit',
    name: 'Bybit',
    component: Bybit,
    meta: { requiresAuth: true }
  },
  {
    path: '/all-coins',
    name: 'AllCoins',
    component: AllCoins,
    meta: { requiresAuth: true }
  },
  {
    path: '/line-chart',
    name: 'LineChart',
    component: Binance,
    meta: { requiresAuth: true }
  },
  {
    path: '/favorite',
    name: 'favoriteBinance',
    component: FavoriteBinance,
    meta: { requiresAuth: true }
  },
  {
    path: '/favorites',
    redirect: '/favorite'
  },
  {
    path: '/metrics',
    redirect: '/binance'
  },
  {
    path: '/multi-coin',
    redirect: '/all-coins'
  },
  {
    path: '/exclusions',
    redirect: '/binance'
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: Profile,
    props: { initialTab: 'password' },
    meta: { requiresAuth: true }
  },
  {
    path: '/account-management',
    name: 'AccountManagement',
    component: AccountManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/accounts',
    name: 'AdminAccounts',
    component: AccountManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/accounts/:id',
    name: 'AdminAccountDetail',
    component: AccountManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { public: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { public: true }
  },
  {
    path: '/forbidden',
    name: 'Forbidden',
    component: Forbidden,
    meta: { public: true }
  },
  {
    path: '/orderbook/:symbol',
    name: 'Orderbook',
    component: OrderbookView,
    meta: { requiresAuth: true }
  },
  {
    path: '/binance-ls-compare',
    name: 'LongShortCompare',
    component: LongShortCompare,
    meta: { public: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to) => {
  if (to.meta.public) {
    return isAuthenticated() && to.path === '/login' ? '/binance' : true;
  }

  if (to.meta.requiresAuth && !isAuthenticated()) {
    return { path: '/login', query: { redirect: to.fullPath } };
  }

  if (to.meta.requiresAuth) {
    try {
      await getValidAccessToken(getAccessToken());
    } catch (e) {
      return true;
    }
  }

  if (to.meta.requiresAdmin && !isAdmin()) {
    return '/forbidden';
  }

  return true;
});

export default router;
